<section class="container pt-5 pb-lg-5 pb-md-4 pb-2">
  <div class="row justify-content-center">
    <div class="col-sm-10 col-md-9 col-lg-6 d-flex flex-column align-items-center">

      <img src="assets/images/illustrations/successful-payment.svg" class="w-75 w-md-50 mt-5 pt-lg-3 pb-md-1 pb-3">
      <h1 class="h2 mt-5">Plata finalizata cu succes</h1>

      <ng-container *ngIf="contribution">
        <p class="mt-4">Felicitari! Contributia ta in valoare de
          <strong>{{contribution.amount}} lei</strong> pentru evenimentul <strong>{{contribution.eventName}}</strong> a
          fost inregistrata
          cu succes azi,
          <strong>{{contribution.contributedDate | date: 'dd/MM/yyyy'}}</strong>, cu numarul de referinta
          <strong>{{contribution.id}}</strong>.
        </p>
        <p class="mb-0">Iti multumim ca ne esti alaturi! 😀</p>
        <p class="text-muted fst-italic">{{contribution.eventUserFirstName}} si GiftShare</p>
      </ng-container>

      <a [routerLink]="['/eveniment', contribution?.eventCode]"
        class="btn btn-lg btn-primary w-100 w-sm-auto mb-3 mb-sm-0 mt-4">Inapoi la
        eveniment</a>

    </div>
  </div>
</section>
